import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M12.02 11.078l2.856 2.855-.944.943-2.854-2.855a6.002 6.002 0 01-9.745-4.687c0-3.313 2.688-6 6-6a6.002 6.002 0 014.687 9.744zm-1.337-.495a4.665 4.665 0 00-3.35-7.917 4.665 4.665 0 00-4.667 4.667 4.665 4.665 0 007.917 3.35l.1-.1zm-2.565-5.8a1.333 1.333 0 101.764 1.765 2.667 2.667 0 11-1.764-1.764z'
      ></path>
    </svg>
  )
}

export default Icon
